import React from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';

import { QUERIES } from '../constants/mediaQueries';

interface BurgerButtonProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  controlsId?: string;
}

const BurgerButtonWrapper = styled.button`
  display: none;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: var(--button-size-burger);
  height: var(--button-size-burger);
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  gap: var(--button-gap-burger);

  ${QUERIES.maxLaptop} {
    display: flex;
  }

  span {
    display: block;
    width: var(--button-size-burger-line-width);
    height: var(--button-size-burger-line-height);
    background-color: var(--color-neutral-darkest);
    border-radius: var(--button-radius-burger-line);
    transform-origin: center;
  }

  &:focus-visible {
    outline: var(--button-focus-outline-width) solid var(--color-neutral-dark);
    outline-offset: var(--button-focus-outline-offset);
  }
`;

const BurgerButton: React.FC<BurgerButtonProps> = ({ open, setOpen, controlsId }) => {
  return (
    <BurgerButtonWrapper
      type="button"
      aria-label={open ? 'Close menu' : 'Open menu'}
      aria-expanded={open}
      aria-controls={controlsId}
      onClick={() => setOpen(!open)}
    >
      <motion.span
        animate={open ? { translateY: 8, rotate: -45 } : { translateY: 0, rotate: 0 }}
        transition={{ duration: 0.2 }}
      />
      <motion.span
        animate={open ? { opacity: 0, scaleX: 0 } : { opacity: 1, scaleX: 1 }}
        transition={{ duration: 0.2 }}
      />
      <motion.span
        animate={open ? { translateY: -8, rotate: 45 } : { translateY: 0, rotate: 0 }}
        transition={{ duration: 0.2 }}
      />
    </BurgerButtonWrapper>
  );
};

export default BurgerButton;
